[
 {
  "image": "/images/formations/charge-de-projet-evenementiel-bloc-de-competence-rncp34927bc03-bloc-de-competence-3-piloter-un-projet-evenementiel.webp",
  "vignette": "/visuels-vitrine/charge-de-projet-evenementiel-bloc-de-competence-rncp34927bc03-bloc-de-competence-3-piloter-un-projet-evenementiel-400.webp",
  "alt": "Cheffe de projet événementiel, tablette en main, qui coordonne son équipe pendant l'installation d'une salle de conférence",
  "fiche": "Formation Chargé de projet événementiel – Bloc de compétence : RNCP34927BC03 – Bloc de compétence 3 : Piloter un projet événementiel"
 },
 {
  "image": "/images/formations/elaborer-une-strategie-de-community-management.webp",
  "vignette": "/visuels-vitrine/elaborer-une-strategie-de-community-management-400.webp",
  "alt": "Mains sur le clavier d'un ordinateur portable, entourées de notifications de réseaux sociaux",
  "fiche": "Élaborer une stratégie de community management"
 },
 {
  "image": "/images/formations/formation-analyse-financiere.webp",
  "vignette": "/visuels-vitrine/formation-analyse-financiere-400.webp",
  "alt": "Visuel de la fiche Analyse Financière",
  "fiche": "Analyse Financière"
 },
 {
  "image": "/images/formations/formation-animer-une-equipe.webp",
  "vignette": "/visuels-vitrine/formation-animer-une-equipe-400.webp",
  "alt": "Un manager et une collègue se tapent dans la main autour d'une table de réunion",
  "fiche": "Formation Animer une équipe"
 },
 {
  "image": "/images/formations/formation-batir-et-piloter-votre-plan-daction-commercial.webp",
  "vignette": "/visuels-vitrine/formation-batir-et-piloter-votre-plan-daction-commercial-400.webp",
  "alt": "Visuel de la fiche Bâtir et Piloter votre Plan d’Action Commercial",
  "fiche": "Bâtir et Piloter votre Plan d’Action Commercial"
 },
 {
  "image": "/images/formations/formation-coaching-systemique-dequipe.webp",
  "vignette": "/visuels-vitrine/formation-coaching-systemique-dequipe-400.webp",
  "alt": "Visuel de la fiche Coaching Systémique d’Equipe",
  "fiche": "Coaching Systémique d’Equipe"
 },
 {
  "image": "/images/formations/formation-couture-creative.webp",
  "vignette": "/visuels-vitrine/formation-couture-creative-400.webp",
  "alt": "Visuel de la fiche Couture créative",
  "fiche": "Couture créative"
 },
 {
  "image": "/images/formations/formation-creation-de-site-internet.webp",
  "vignette": "/visuels-vitrine/formation-creation-de-site-internet-400.webp",
  "alt": "Visuel de la fiche Création de site Internet",
  "fiche": "Création de site Internet"
 },
 {
  "image": "/images/formations/formation-creer-et-administrer-son-site.webp",
  "vignette": "/visuels-vitrine/formation-creer-et-administrer-son-site-400.webp",
  "alt": "Visuel de la fiche Formation Créer et administrer son site",
  "fiche": "Formation Créer et administrer son site"
 },
 {
  "image": "/images/formations/formation-de-formateur.webp",
  "vignette": "/visuels-vitrine/formation-de-formateur-400.webp",
  "alt": "Visuel de la fiche Formation de formateur",
  "fiche": "Formation de formateur"
 },
 {
  "image": "/images/formations/formation-developper-ses-competences-manageriales.webp",
  "vignette": "/visuels-vitrine/formation-developper-ses-competences-manageriales-400.webp",
  "alt": "Manager souriante assise à son bureau devant un ordinateur portable",
  "fiche": "Formation Développer ses Compétences Managériales"
 },
 {
  "image": "/images/formations/formation-en-outils-collaboratifs.webp",
  "vignette": "/visuels-vitrine/formation-en-outils-collaboratifs-400.webp",
  "alt": "Visuel de la fiche Outils collaboratifs",
  "fiche": "Outils collaboratifs"
 },
 {
  "image": "/images/formations/formation-en-sea-referencement-payant.webp",
  "vignette": "/visuels-vitrine/formation-en-sea-referencement-payant-400.webp",
  "alt": "Visuel de la fiche SEA – Référencement Payant",
  "fiche": "SEA – Référencement Payant"
 },
 {
  "image": "/images/formations/formation-financer-un-projet-culturel.webp",
  "vignette": "/visuels-vitrine/formation-financer-un-projet-culturel-400.webp",
  "alt": "Visuel de la fiche Financer un projet culturel",
  "fiche": "Financer un projet culturel"
 },
 {
  "image": "/images/formations/formation-gestion-des-conflits.webp",
  "vignette": "/visuels-vitrine/formation-gestion-des-conflits-400.webp",
  "alt": "Visuel de la fiche Gestion des conflits en situation professionnelle",
  "fiche": "Gestion des conflits en situation professionnelle"
 },
 {
  "image": "/images/formations/formation-gestion-des-emotions.webp",
  "vignette": "/visuels-vitrine/formation-gestion-des-emotions-400.webp",
  "alt": "Visuel de la fiche Gestion des émotions",
  "fiche": "Gestion des émotions"
 },
 {
  "image": "/images/formations/formation-gestion-des-priorites.webp",
  "vignette": "/visuels-vitrine/formation-gestion-des-priorites-400.webp",
  "alt": "Schéma d'un réseau de personnes reliées entre elles",
  "fiche": "Gestion des priorités"
 },
 {
  "image": "/images/formations/formation-gestion-et-pilotage-dentreprise-tpe.webp",
  "vignette": "/visuels-vitrine/formation-gestion-et-pilotage-dentreprise-tpe-400.webp",
  "alt": "Visuel de la fiche Gestion et pilotage d’entreprise TPE",
  "fiche": "Gestion et pilotage d’entreprise TPE"
 },
 {
  "image": "/images/formations/formation-ingenierie-de-projet.webp",
  "vignette": "/visuels-vitrine/formation-ingenierie-de-projet-400.webp",
  "alt": "Visuel de la fiche Ingénierie de projet",
  "fiche": "Ingénierie de projet"
 },
 {
  "image": "/images/formations/formation-innover-grace-au-design-thinking.webp",
  "vignette": "/visuels-vitrine/formation-innover-grace-au-design-thinking-400.webp",
  "alt": "Femme pensive, la main sous le menton, en pleine réflexion",
  "fiche": "Innover grâce au Design Thinking"
 },
 {
  "image": "/images/formations/formation-intelligence-collective.webp",
  "vignette": "/visuels-vitrine/formation-intelligence-collective-400.webp",
  "alt": "Vue du dessus de trois collègues qui travaillent ensemble sur des plans",
  "fiche": "Résoudre les problèmes grâce à l’intelligence collective"
 },
 {
  "image": "/images/formations/formation-lallemand-des-affaires.webp",
  "vignette": "/visuels-vitrine/formation-lallemand-des-affaires-400.webp",
  "alt": "Visuel de la fiche L’allemand des affaires",
  "fiche": "L’allemand des affaires"
 },
 {
  "image": "/images/formations/formation-langlais-des-affaires.webp",
  "vignette": "/visuels-vitrine/formation-langlais-des-affaires-400.webp",
  "alt": "Visuel de la fiche L’anglais des affaires",
  "fiche": "L’anglais des affaires"
 },
 {
  "image": "/images/formations/formation-lart-du-closing.webp",
  "vignette": "/visuels-vitrine/formation-lart-du-closing-400.webp",
  "alt": "Visuel de la fiche L’art du Closing",
  "fiche": "L’art du Closing"
 },
 {
  "image": "/images/formations/formation-le-francais-des-affaires.webp",
  "vignette": "/visuels-vitrine/formation-le-francais-des-affaires-400.webp",
  "alt": "Visuel de la fiche Le Français des affaires",
  "fiche": "Le Français des affaires"
 },
 {
  "image": "/images/formations/formation-le-japonais-des-affaires.webp",
  "vignette": "/visuels-vitrine/formation-le-japonais-des-affaires-400.webp",
  "alt": "Visuel de la fiche Le japonais des affaires",
  "fiche": "Le japonais des affaires"
 },
 {
  "image": "/images/formations/formation-le-mandarin-des-affaires.webp",
  "vignette": "/visuels-vitrine/formation-le-mandarin-des-affaires-400.webp",
  "alt": "Visuel de la fiche Le Mandarin des affaires",
  "fiche": "Le Mandarin des affaires"
 },
 {
  "image": "/images/formations/formation-le-mecenat-dentreprise.webp",
  "vignette": "/visuels-vitrine/formation-le-mecenat-dentreprise-400.webp",
  "alt": "Visuel de la fiche Le mécénat d’entreprise",
  "fiche": "Le mécénat d’entreprise"
 },
 {
  "image": "/images/formations/formation-le-portugais-des-affaires.webp",
  "vignette": "/visuels-vitrine/formation-le-portugais-des-affaires-400.webp",
  "alt": "Visuel de la fiche Le portugais des affaires",
  "fiche": "Le portugais des affaires"
 },
 {
  "image": "/images/formations/formation-leconomie-circulaire-dans-son-processus-de-production.webp",
  "vignette": "/visuels-vitrine/formation-leconomie-circulaire-dans-son-processus-de-production-400.webp",
  "alt": "Visuel de la fiche L’économie circulaire dans son processus de production",
  "fiche": "L’économie circulaire dans son processus de production"
 },
 {
  "image": "/images/formations/formation-lespagnol-des-affaires.webp",
  "vignette": "/visuels-vitrine/formation-lespagnol-des-affaires-400.webp",
  "alt": "Visuel de la fiche L’espagnol des affaires",
  "fiche": "L’espagnol des affaires"
 },
 {
  "image": "/images/formations/formation-litalien-des-affaires.webp",
  "vignette": "/visuels-vitrine/formation-litalien-des-affaires-400.webp",
  "alt": "Visuel de la fiche L’italien des affaires",
  "fiche": "L’italien des affaires"
 },
 {
  "image": "/images/formations/formation-maitriser-canva.webp",
  "vignette": "/visuels-vitrine/formation-maitriser-canva-400.webp",
  "alt": "Visuel de la fiche Maîtriser Canva pour sublimer votre communication",
  "fiche": "Maîtriser Canva pour sublimer votre communication"
 },
 {
  "image": "/images/formations/formation-maitriser-la-methode-aec-disc.webp",
  "vignette": "/visuels-vitrine/formation-maitriser-la-methode-aec-disc-400.webp",
  "alt": "Jeune homme souriant en costume, bras croisés",
  "fiche": "Maîtriser la méthode AEC DISC"
 },
 {
  "image": "/images/formations/formation-maitriser-lart-des-tableurs.webp",
  "vignette": "/visuels-vitrine/formation-maitriser-lart-des-tableurs-400.webp",
  "alt": "Visuel de la fiche Maîtriser l’art des tableurs",
  "fiche": "Maîtriser l’art des tableurs"
 },
 {
  "image": "/images/formations/formation-maitriser-le-francais-professionnel-preparation-a-la-certification-le-robert.webp",
  "vignette": "/visuels-vitrine/formation-maitriser-le-francais-professionnel-preparation-a-la-certification-le-robert-400.webp",
  "alt": "Jeune femme souriante en chemisier blanc, bras croisés",
  "fiche": "Maîtriser le français professionnel – Préparation à la Certification en langue française Le Robert"
 },
 {
  "image": "/images/formations/formation-maitriser-les-logiciels-de-presentation-pao.webp",
  "vignette": "/visuels-vitrine/formation-maitriser-les-logiciels-de-presentation-pao-400.webp",
  "alt": "Visuel de la fiche Maîtriser les logiciels de présentation PAO (Powerpoint)",
  "fiche": "Maîtriser les logiciels de présentation PAO (Powerpoint)"
 },
 {
  "image": "/images/formations/formation-maitriser-les-reseaux-sociaux.webp",
  "vignette": "/visuels-vitrine/formation-maitriser-les-reseaux-sociaux-400.webp",
  "alt": "Visuel de la fiche Maîtriser les Réseaux Sociaux",
  "fiche": "Maîtriser les Réseaux Sociaux"
 },
 {
  "image": "/images/formations/formation-maitrisez-lart-du-referencement-naturel-seo.webp",
  "vignette": "/visuels-vitrine/formation-maitrisez-lart-du-referencement-naturel-seo-400.webp",
  "alt": "Visuel de la fiche Formation Maîtrisez l’Art du Référencement naturel SEO",
  "fiche": "Formation Maîtrisez l’Art du Référencement naturel SEO"
 },
 {
  "image": "/images/formations/formation-mao-production-musicale-avec-cubase.webp",
  "vignette": "/visuels-vitrine/formation-mao-production-musicale-avec-cubase-400.webp",
  "alt": "Visuel de la fiche MAO – Production musicale avec Cubase",
  "fiche": "MAO – Production musicale avec Cubase"
 },
 {
  "image": "/images/formations/formation-oenologie.webp",
  "vignette": "/visuels-vitrine/formation-oenologie-400.webp",
  "alt": "Visuel de la fiche Œnologie",
  "fiche": "Œnologie"
 },
 {
  "image": "/images/formations/formation-photographie.webp",
  "vignette": "/visuels-vitrine/formation-photographie-400.webp",
  "alt": "Jeune homme qui prend une photo avec un appareil hybride",
  "fiche": "Photographie – Maîtrisez l’art de la photographie"
 },
 {
  "image": "/images/formations/formation-prendre-la-parole-en-public-avec-aisance.webp",
  "vignette": "/visuels-vitrine/formation-prendre-la-parole-en-public-avec-aisance-400.webp",
  "alt": "Visuel de la fiche Prendre la parole en public avec aisance",
  "fiche": "Prendre la parole en public avec aisance"
 },
 {
  "image": "/images/formations/formation-prise-en-main-dun-pc-mac.webp",
  "vignette": "/visuels-vitrine/formation-prise-en-main-dun-pc-mac-400.webp",
  "alt": "Visuel de la fiche Prise en main d’un PC/MAC",
  "fiche": "Prise en main d’un PC/MAC"
 },
 {
  "image": "/images/formations/formation-produire-du-contenu-video-avec-votre-smartphone.webp",
  "vignette": "/visuels-vitrine/formation-produire-du-contenu-video-avec-votre-smartphone-400.webp",
  "alt": "Visuel de la fiche Produire du contenu vidéo avec votre smartphone",
  "fiche": "Produire du contenu vidéo avec votre smartphone"
 },
 {
  "image": "/images/formations/formation-prothesiste-ongulaire.webp",
  "vignette": "/visuels-vitrine/formation-prothesiste-ongulaire-400.webp",
  "alt": "Main aux ongles vernis rose pailleté, posée sur une dentelle blanche",
  "fiche": "Créer son cabinet de prothésiste ongulaire"
 },
 {
  "image": "/images/formations/formation-reduire-lempreinte-carbone-dans-son-entreprise.webp",
  "vignette": "/visuels-vitrine/formation-reduire-lempreinte-carbone-dans-son-entreprise-400.webp",
  "alt": "Visuel de la fiche Réduire l’empreinte carbone dans son entreprise",
  "fiche": "Réduire l’empreinte carbone dans son entreprise"
 },
 {
  "image": "/images/formations/formation-reinventer-les-reunions-dequipe.webp",
  "vignette": "/visuels-vitrine/formation-reinventer-les-reunions-dequipe-400.webp",
  "alt": "Deux collègues souriantes qui suivent attentivement une réunion",
  "fiche": "Réinventer les réunions d’équipe"
 },
 {
  "image": "/images/formations/formation-reussir-le-lancement-de-sa-start-up.webp",
  "vignette": "/visuels-vitrine/formation-reussir-le-lancement-de-sa-start-up-400.webp",
  "alt": "Visuel de la fiche Réussir le lancement de sa start Up!",
  "fiche": "Réussir le lancement de sa start Up!"
 },
 {
  "image": "/images/formations/formation-reussir-sa-prospection-telephonique.webp",
  "vignette": "/visuels-vitrine/formation-reussir-sa-prospection-telephonique-400.webp",
  "alt": "Visuel de la fiche Réussir sa prospection téléphonique",
  "fiche": "Réussir sa prospection téléphonique"
 },
 {
  "image": "/images/formations/formation-traitement-de-texte.webp",
  "vignette": "/visuels-vitrine/formation-traitement-de-texte-400.webp",
  "alt": "Visuel de la fiche Traitement de texte – de l’initiation au perfectionnement",
  "fiche": "Traitement de texte – de l’initiation au perfectionnement"
 },
 {
  "image": "/images/formations/formation-vente-conseil.webp",
  "vignette": "/visuels-vitrine/formation-vente-conseil-400.webp",
  "alt": "Visuel de la fiche Vente Conseil",
  "fiche": "Vente Conseil"
 },
 {
  "image": "/images/formations/management-operationnel-performance-equipe.webp",
  "vignette": "/visuels-vitrine/management-operationnel-performance-equipe-400.webp",
  "alt": "Manager souriant qui anime une réunion devant une équipe qui lève la main",
  "fiche": "Piloter la performance d’équipe et adopter un management adapté aux collaborateurs"
 },
 {
  "image": "/images/formations/mettre-lia-au-service-de-sa-strategie-de-developpement.webp",
  "vignette": "/visuels-vitrine/mettre-lia-au-service-de-sa-strategie-de-developpement-400.webp",
  "alt": "Mains de robot utilisant un ordinateur portable, une tablette et un smartphone",
  "fiche": "Mettre l’IA au service de sa stratégie de développement"
 },
 {
  "image": "/images/formations/vente-b2b-developper-ses-competences-commerciales.webp",
  "vignette": "/visuels-vitrine/vente-b2b-developper-ses-competences-commerciales-400.webp",
  "alt": "Poignée de main entre deux professionnels en costume",
  "fiche": "Vente B2B – Développer ses compétences commerciales"
 }
]